import { ComponentPropsWithoutRef } from 'react';

export type TableCellProps = ComponentPropsWithoutRef<'td'>;

export const TableCell = ({ ...props }: TableCellProps) => <td {...props} />;
